function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import { getInitialValue } from '../inputs/utils';
import { getAdditionalProps } from '../utils/propTypes';
import { VALUES_PROP_TYPE, PLACEHOLDER_DUMMY_VALUE } from './constants';
import Icon from '../icon/Icon';
import ChevronDownChunkySvg from '../iconography/icons/ChevronDownChunky';
/**
 * Helper component for Select options
 * @prop {string} value - the value of the field if this option is selected
 * @prop {string} display - the text of option displayed to user
 * @example
 * // <SelectOption value="option_01" display="Option 01" />
 */

var SelectOption = function SelectOption(_ref) {
  var value = _ref.value,
      display = _ref.display;
  return React.createElement("option", {
    value: value,
    "data-spec": "select-option"
  }, display);
};
/**
 * An initial implementation of a single-select component
 * @extends PureComponent
 * @example
 * // <Select
 * //   id="my-field"
 * //   name="my-field"
 * //   values={[{value: '01', display: 'Choice 01'}, {value: '02', display: 'Choice 02'}]}
 * //   onChange={this.selectChanged.bind(this)}
 * // />
**/


var Select =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Select, _PureComponent);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));
    var value = props.value,
        defaultValue = props.defaultValue,
        placeholder = props.placeholder,
        values = props.values;
    _this.state = {
      value: getInitialValue(value || defaultValue, values, placeholder),
      active: false
    };
    return _this;
  }

  _createClass(Select, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref2) {
      var value = _ref2.value,
          values = _ref2.values,
          placeholder = _ref2.placeholder;

      // allows setting an existing `input` element's value via props from a parent
      if (value !== undefined) {
        this.setState({
          value: getInitialValue(value, values, placeholder)
        });
      }
    }
  }, {
    key: "_handleChange",
    value: function _handleChange(e) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          placeholder = _this$props.placeholder;
      var value = e.target.value; // If there's a placeholder and the user picks that placeholder first value
      // (presumably after picking a normal value), we'll treat it as a no-op.
      // We definitely don't want to fire the onChange event, but also not setting
      // the state so that onBlur & onFocus don't unintentionally pass back the
      // value we don't them to

      if (placeholder && value === PLACEHOLDER_DUMMY_VALUE) {
        return;
      }

      this.setState({
        value: value
      });

      if (onChange) {
        onChange(value);
      }
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur() {
      this.setState({
        active: false
      });

      if (this.props.onBlur) {
        this.props.onBlur(this.state.value);
      }
    }
  }, {
    key: "_handleFocus",
    value: function _handleFocus() {
      this.setState({
        active: true
      });

      if (this.props.onFocus) {
        this.props.onFocus(this.state.value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var values = this.props.values;
      var _this$props2 = this.props,
          name = _this$props2.name,
          id = _this$props2.id,
          placeholder = _this$props2.placeholder,
          required = _this$props2.required,
          hasError = _this$props2.hasError,
          disabled = _this$props2.disabled,
          dataSpec = _this$props2['data-spec'],
          __containerClassName = _this$props2.__containerClassName;
      var extraAttrs = getAdditionalProps(this);
      var _this$state = this.state,
          selectedValue = _this$state.value,
          active = _this$state.active;
      var selectedDisplay;

      if (placeholder) {
        values = [{
          display: placeholder,
          value: PLACEHOLDER_DUMMY_VALUE
        }].concat(_toConsumableArray(values));
      }

      var wrapperClassName = classNames('eds-select', {
        'eds-select--disabled': disabled,
        'eds-select--focus': active,
        'eds-select--error': hasError
      }, __containerClassName); // Build up the list of optionComponents and determine the selected
      // display in one iteration. We're determining this derived value here
      // instead of storing it in state

      var optionComponents = values.map(function (valueInfo) {
        // setting this value is a side effect of the single iteration
        if (valueInfo.value === selectedValue) {
          selectedDisplay = valueInfo.display;
        }

        return React.createElement(SelectOption, {
          value: valueInfo.value,
          display: valueInfo.display,
          key: valueInfo.value
        });
      });
      return React.createElement("div", {
        className: wrapperClassName,
        "data-spec": "select-wrapper"
      }, React.createElement("label", {
        htmlFor: id,
        className: "eds-select__value",
        "data-spec": "select-display"
      }, selectedDisplay, React.createElement("span", {
        className: "eds-select__icon"
      }, React.createElement(Icon, {
        type: React.createElement(ChevronDownChunkySvg, null),
        color: "grey-600"
      }))), React.createElement("select", _extends({
        className: "eds-select__input",
        "data-spec": dataSpec
      }, extraAttrs, {
        id: id,
        name: name,
        disabled: disabled,
        "aria-required": required,
        "aria-invalid": hasError,
        value: selectedValue,
        onChange: this._handleChange.bind(this),
        onBlur: this._handleBlur.bind(this),
        onFocus: this._handleFocus.bind(this)
      }), optionComponents));
    }
  }]);

  return Select;
}(PureComponent);

_defineProperty(Select, "propTypes", {
  /**
   * Array of formatted options
  */
  values: VALUES_PROP_TYPE.isRequired,

  /**
   * Form name of select component
  */
  name: PropTypes.string,

  /**
   * ID of select component
  */
  id: PropTypes.string,

  /**
   * Default value selected from the values array
  */
  defaultValue: PropTypes.string,
  value: PropTypes.string,

  /**
   * Text to be displayed when no option is selected
  */
  placeholder: EBPropTypes.translation,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  __containerClassName: PropTypes.string,

  /**
   * Function to be invoked when select value changes
  */
  onChange: PropTypes.func,

  /**
   * Function to be invoked when the component is on blur
  */
  onBlur: PropTypes.func,

  /**
   * Function to be invoked when the component is on focus
  */
  onFocus: PropTypes.func,

  /**
   * Identifier for tests
   */
  'data-spec': PropTypes.string
});

_defineProperty(Select, "defaultProps", {
  'data-spec': 'select-input'
});

export { Select as default };